import React from 'react'
import img2 from '../components/images/laser/laser1.png'
import LaserPrinterWebsite from './LaserPrinterWebsite'

function LaserPrinter() {
  return (
    <div>
        <section>
            <div className="w-full h-full relative mt-5 font-poppins">
                <img
                    src={img2}
                    alt="Banner"
                    className="w-full h-full object-cover"
                />
            </div>
                
        </section>
        <section>
            <LaserPrinterWebsite/>
        </section>
    </div>
  )
}

export default LaserPrinter
